import { render, staticRenderFns } from "./budget-new.vue?vue&type=template&id=3e0734a6&"
import script from "./budget-new.vue?vue&type=script&lang=js&"
export * from "./budget-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports